import Link from 'next/link'

import styled from 'styled-components'
import themeGet from '@styled-system/theme-get'

import { Flex } from 'Components/UI'
import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import {
  LANDING_INLINE_PADDINGS,
  LANDING_MAX_CONTENT_WIDTH_PX,
} from 'Constants/Landing'

const shouldForwardProp = prop => {
  return !DIV_SHOULD_FORWARD_PROP.includes(String(prop))
}

export const Container = styled(Flex)
  .attrs({
    width: 1,
    justifyContent: 'center',
    pb: [32, 64],
    pt: [16, 24],
    px: LANDING_INLINE_PADDINGS,
  })
  .withConfig({
    shouldForwardProp,
  })`
  background-color: ${themeGet('colors.bg.secondary')};
`

export const Content = styled(Flex)
  .attrs({
    width: 1,
  })
  .withConfig({
    shouldForwardProp,
  })`
  flex-direction: column;
  border-radius: 24px;
  overflow: hidden;
  background-color: ${themeGet('colors.white')};
  max-width: ${LANDING_MAX_CONTENT_WIDTH_PX}px;
`

export const MainContent = styled(Flex).attrs({
  px: [16, 40],
  pt: [16, 24],
  pb: [16, 48],
})`
  width: 100%;
  height: 100%;
  flex-direction: column;
  flex-grow: 1;
`

export const FooterContent = styled(Flex)
  .attrs({
    flexDirection: ['column', 'row'],
  })
  .withConfig({
    shouldForwardProp,
  })`
  flex-wrap: wrap;
  justify-content: space-between;
`

export const Authors = styled(Flex)`
  align-items: center;
  flex-wrap: wrap;
`

export const Author = styled(Flex).attrs({
  mt: [1, 0],
})`
  align-items: center;
`

export const BlogLink = styled(Link)`
  cursor: pointer;
  text-decoration: none;

  > h2 {
    color: ${themeGet('colors.text.link')};

    &:hover {
      color: ${themeGet('colors.text.linkHover')};
    }
  }
`

export const ImageHolder = styled(Flex)
  .attrs({
    height: [250, 300, 340],
  })
  .withConfig({
    shouldForwardProp,
  })`
  width: 100%;
  flex-shrink: 0;
  overflow: hidden;
  background-color: ${themeGet('colors.bunting')};

  > div {
    width: 100%;
    max-width: unset !important;
  }

  img {
    width: 100%;
    object-fit: cover;
  }

  div:first-child {
    width: 100%;
  }
`

export const AvatarHolder = styled(Flex).attrs({
  ml: [0, '8px'],
})`
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border-radius: 50%;
  overflow: hidden;

  img {
    width: 100%;
    object-fit: cover;
  }
`
